import { httpCreate } from './http';

const http = httpCreate('/srv/gather-statistics-pie/');

export const gatherStatisticsPie = {
	// 获取性别数据
	getSexData(albumId, params) {
		return http.get(`sexParticipants/${albumId}`, { params });
	},
	// 获取来源数据
	/**
	 * @param { Number } albumId
	 * @param { Number } params.isTotal
	 */
	getPlatformData(albumId, params) {
		return http.get(`platformParticipants/${albumId}`, { params });
	},
};
